<div class="modal-backdrop" (click)="closeModal()"></div>

<div class="modal-card">

    <button class="close-btn" (click)="closeModal()">
        <i class="bi bi-close"></i>
    </button>

    <!-- Header -->
    <div class="header-row">
        <div class="header-left">
            <h2 class="title">{{ data.quizTitle }}</h2>
            <p class="subtitle">Users who attempted this quiz</p>
        </div>

        <div class="total">
            <p class="meta-label">Total Attempts</p>
            <p class="total-count">{{ data.totalAttempts }}</p>
        </div>
    </div>

    <!-- Course -->
    <div class="course-row">
        <p class="meta-label">Course</p>
        <p class="course-name">{{ data.courseName }}</p>
    </div>

    <!-- Users List -->
    <div class="user-list">

        <div class="user-header-row">
            <span>User</span>
            <span>Attempt Date</span>
            <span>Score</span>
        </div>

        <!-- Users -->
        <ng-container *ngIf="data.users?.length; else noAttempts">

            <div class="user-row" *ngFor="let u of data.users">

                <div class="user-info">
                    <div class="avatar">{{ u.initials }}</div>

                    <div class="user-text">
                        <p class="name" [title]="u.name">
                            {{ u.name | slice:0:14 }}{{ u.name.length > 14 ? '...' : '' }}
                        </p>

                        <p class="email" [title]="u.email">
                            {{ u.email | slice:0:14 }}{{ u.email.length > 14 ? '...' : '' }}
                        </p>
                    </div>
                </div>

                <p class="date">{{ u.attemptDate }}</p>

                <span class="score-badge" [ngClass]="getBadgeClass(u.score)">
                    {{ u.score }}%
                </span>

            </div>

        </ng-container>

        <!-- Empty State -->
        <ng-template #noAttempts>
            <div class="no-data">
                <span class="material-icons">info</span>
                <p>No quiz attempts found</p>
            </div>
        </ng-template>

    </div>

    <!-- Footer -->
    <div class="footer">
        <button class="btn-outline" (click)="closeModal()">Close</button>
    </div>
</div>